/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-20 08:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import Attribute from 'src/components/containers/merchandising-v2/rule/strategy/banners/render-settings';
import { Button } from '@shopify/polaris';
import { getFormValues, reset, FieldArray, change } from 'redux-form';
import { NUMBER_ATTRIBUTE_PER_RULE } from 'src/constants/merchandising-v2';

type Props = {
  type: String,
  strategies: Array<{
    type: String,
    attributes?: Array<Object>,
    position: Number,
    imgSrc: File | Object,
    name: String,
    link: String,
    openInNewTab: Boolean
  }>,
  selectedIndex: Number,
  updateField: Function
};

type ComposedProps = Props & WithI18nProps;

const Banners = (props: ComposedProps) => {
  const { i18n, type, strategies, updateField, selectedIndex, allThemes = [], formValues } = props;
  const handleAddStrategy = (nextStrategies = null) => {
    let clonedStrategies = _.cloneDeep(nextStrategies ? nextStrategies : strategies);

    clonedStrategies.push({
      type,
      openInNewTab: true
    });

    // Update suggestion form
    updateField('strategies', clonedStrategies);
  };

  const initValueModal = (type, strategies) => {
    const filterStrategyByType = strategies.filter(e => e.type === type);
    if (filterStrategyByType.length <= 0) {
      handleAddStrategy(strategies);
    }
  };

  useEffect(() => {
    // Init value when open modal
    initValueModal(type, strategies);
  }, []);

  const filterAttributeByType = strategies.filter(e => _.get(e, 'type', '') === type);
  const mainTheme = _.find(allThemes, theme => theme.role === 'main') || {};

  return (
    <div>
      <FieldArray
        name="strategies"
        component={Attribute}
        formValues={formValues}
        mainTheme={mainTheme}
        updateField={updateField}
        strategies={strategies}
        type={type}
        maxCondition={NUMBER_ATTRIBUTE_PER_RULE[type]}
        selectedIndex={selectedIndex}
      />
      {filterAttributeByType.length < NUMBER_ATTRIBUTE_PER_RULE[type] && (
        <div className="card-section card-add-field-attribute wrap-attribute">
          <div className="add-field-attribute">
            <Button onClick={() => handleAddStrategy()}>
              {i18n.translate('AdminHTML.MerchandisingV2.AttributesModal.addNew')}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const { strategies } = props;
  const formValues = getFormValues('MerchandisingV2RuleForm')(state);
  return {
    formValues,
    allThemes: _.get(state.themeSetupV3, 'allThemes', []),
    strategies
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  resetForm: () => dispatch(reset('MerchandisingV2RuleForm')),
  // Update redux-form field
  updateField: (field, value) => dispatch(change(`MerchandisingV2RuleForm`, field, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(Banners));
